import { render } from "./Competitors.vue?vue&type=template&id=1567b346"
import script from "./Competitors.vue?vue&type=script&lang=js"
export * from "./Competitors.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__